import Page from "../../page";
import React from "react";
import DataGrid2 from "../../../components/data/dataGrid2";
import DataView from "../../../components/data/dataView";
import Card from "../../../components/general/card";
import DataRow from "../../../components/data/dataRow";
import DataManager from "../../../components/data/dataManager";
import embeddableText from "../../../scripts/embeddableText";
import FileEmbed from "../../../components/shared/fileEmbed";

class SafetyAnnouncements extends Page {
    private data_grid: React.RefObject<DataGrid2>;
    private data_view: React.RefObject<DataView>;
    private file_embed: React.RefObject<FileEmbed>;

    constructor(props: any) {
        super(props);
        this.props = props;

        this.data_grid = React.createRef<DataGrid2>();
        this.data_view = React.createRef<DataView>();
        this.file_embed = React.createRef<FileEmbed>();
    }

    renderAlways() {
        return (<div>
            <ol className="custom_breadcrumb center-x">
                <li className="breadcrumb-item"><a href="../home">Home</a></li>
                <li className="breadcrumb-item"><a href="../admin">Admin</a></li>
                <li className="breadcrumb-item">Safety Announcements</li>
            </ol>
            <FileEmbed ref={this.file_embed} data_view={this.data_view} data_field_idx={0}></FileEmbed>
            <Card colour="info" title="Safety Announcements">
                <div>
                    <DataGrid2 ref={this.data_grid} url="crud/announcements/search"
                               row_selector={[]}
                               header_titles={["Description", "Created", "Priority", "Your Action"]}
                               header_sizes={[6, 2, 2, 2]}
                               cell_body_extractors={[
                                   (d: any) => (<p>{embeddableText(d["description"])}</p>),
                                   (d: any) => (<p>{d["createdAt"].replace("T", " ")}</p>),
                                   (d: any) => (
                                       <p>{d["priority"] == 0 ? "High" : (d["priority"] == 1 ? "Med" : "Low")}</p>),
                                   (d: any) => (<p>{d["action"]}</p>)
                               ]}
                               row_styler={(rowData: any) => {
                                   return {fontWeight: (rowData["hasRead"] ? "" : "bold")}
                               }}
                               row_clicked={(index: number, row_data: any, row_element: React.RefObject<DataRow>) => {
                                   this.data_view.current?.data_grid_row_selected(index, row_data)
                               }}
                    />
                    <DataManager data_grid={this.data_grid} action_url="crud/announcements"
                                 add_enabled={true} delete_enabled={true}
                                 data_view={this.data_view}
                                 update_data_key={[]}
                                 default_obj={{
                                     action: "New Action",
                                     description: "New Announcement",
                                     strPriority: "0"
                                 }}
                    />
                    <DataView ref={this.data_view} data_grid={this.data_grid}
                              field_labels={["Description", "Priority (0-High 1-Med 2-Low)", "Their Action"]}
                              field_value_selector={[["description"], ["strPriority"], ["action"]]}
                              field_readonly={[false, false, false]}
                              field_types={["string", "string", "string"]}
                    />
                    <button className="btn btn-success" onClick={(event => {
                        this.file_embed.current?.show();
                    })} type="button">Embed A File
                    </button>
                </div>
            </Card>
        </div>);
    }

}

export default SafetyAnnouncements;
